export default __webpack_public_path__ + "static/media/post.9bcc601b.png";